import { useEffect, useRef, useState } from "react"

import { useDispatch } from "react-redux";

import { useNavigate } from "react-router";

import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, Switch, TextField } from "@mui/material";

import UndoIcon from "@mui/icons-material/Undo";

import { CustomToolbarItemModel, DocumentEditorContainerComponent, ToolbarItem } from "@syncfusion/ej2-react-documenteditor"
import { DropDownButton, ItemModel, MenuEventArgs } from "@syncfusion/ej2-react-splitbuttons"

import { DefaultDocumentEditor } from "../../helpers/DefaultDocumentEditor";

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { DialogContentStyle, DialogActionsStyle } from "../../styles/DialogStyle";

import { Layout } from "../../components/Layout"
import { CircularProgressIndicator } from "../../components/CircularProgressIndicator";

import { ObtenerAutoridades } from "../../connections/catalogos/AutoridadConnection"
import { ObtenerTipoAcuerdo } from "../../connections/catalogos/TipoAcuerdoConnection";
import { ObtenerSubTipoAcuerdo } from "../../connections/catalogos/SubTipoAcuerdoConnection";
import { ActualizarPlantilla, AgregarPlantilla, ObtenerPlantillasAdmin } from "../../connections/admin/PlantillaConnection";
import { ObtenerTipoNotificacion } from "../../connections/catalogos/TipoNotificacionConnection";

import { AutoridadProps } from "../../interfaces/catalogos/AutoridadInterface";
import { TipoAcuerdoProps } from "../../interfaces/catalogos/TipoAcuerdoInterface";
import { SubTipoAcuerdoProps } from "../../interfaces/catalogos/SubTipoAcuerdoInterface";
import { PlantillaAdminProps, PlantillaProps } from "../../interfaces/admin/PlantillaInterface";
import { TipoNotificacionProps } from "../../interfaces/catalogos/TipoNotificacionInterface";

type actionType = 'Nueva plantilla' | 'Modificar plantilla';
type TipoPlantillaType = 'Acuerdos' | 'Notificacion';

const defaultDocument = DefaultDocumentEditor();

export const PlantillasPage = () => {

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const syncfusionEditor = useRef<DocumentEditorContainerComponent | null>( null );

    const [tipoAccion, setTipoAccion] = useState<actionType>( 'Nueva plantilla' );
    const [tipoPlantilla, setTipoPlantilla] = useState<TipoPlantillaType>( 'Acuerdos' );

    const [activarPlantilla, setActivarPlantilla] = useState( false );

    const [open, setOpen] = useState( false );
    const [loading, setLoading] = useState( true );
    const [loadingGuardar, setLoadingGuardar] = useState( false );

    const [editorReady, setEditorReady] = useState( false );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [tipoAcuerdo, setTipoAcuerdo] = useState( 0 );
    const [tipoAcuerdoArray, setTipoAcuerdoArray] = useState<TipoAcuerdoProps[]>( [] );

    const [subtipoAcuerdo, setsubTipoAcuerdo] = useState( 0 );
    const [subtipoAcuerdoArray, setSubTipoAcuerdoArray] = useState<SubTipoAcuerdoProps[]>( [] );

    const [tipoNotificacion, setTipoNotificacion] = useState( 0 );
    const [tipoNotificacionArray, setTipoNotificacionArray] = useState<TipoNotificacionProps[]>( [] );

    const [nombrePlantilla, setNombrePlantilla] = useState( '' );

    const [plantilla, setPlantilla] = useState( 0 );
    const [plantillaArray, setPlantillaArray] = useState<PlantillaAdminProps[]>( [] );

    const campos = [
        { id: '1', text: 'Fecha Actual', iconCss: 'e-icons e-bookmark', shortcut: '[Fecha_Actual]' },
        { id: '2', text: 'Hora', iconCss: 'e-icons e-bookmark', shortcut: '[Hora]' },
        { id: '3', text: 'Número de expediente', iconCss: 'e-icons e-bookmark', shortcut: '[Numero_Expediente]' },
        { id: '4', text: 'Número de exhorto', iconCss: 'e-icons e-bookmark', shortcut: '[Numero_Exhorto]' },
        { id: '5', text: 'Número de Oficio', iconCss: 'e-icons e-bookmark', shortcut: '[Numero_Oficio]'  },
        { id: '6', text: 'Número de Irregular', iconCss: 'e-icons e-bookmark', shortcut: '[Numero_Irregular]'  },
        { id: '7', text: 'Número de amparo', iconCss: 'e-icons e-bookmark', shortcut: '[Numero_Amparo]'  },
        { id: '8', text: 'Número de origen exhorto', iconCss: 'e-icons e-bookmark', shortcut: '[Numero_Origen_Exhorto]'  },
        { id: '9', text: 'Número de expedientillo de susp.', iconCss: 'e-icons e-bookmark', shortcut: '[Numero_Expedientillo_de_susp]'  },
        { id: '10', text: 'Tipo de Juicio', iconCss: 'e-icons e-bookmark', shortcut: '[Tipo_Juicio]'  },
        { id: '11', text: 'Tipo de Irregular', iconCss: 'e-icons e-bookmark', shortcut: '[Tipo_Irregular]'  },
        { id: '12', text: 'Autoridad de exhorto', iconCss: 'e-icons e-bookmark', shortcut: '[Autoridad_Exhorto]'  },
        { id: '13', text: 'Autoridad de amparo', iconCss: 'e-icons e-bookmark', shortcut: '[Autoridad_Amparo]'  },
        { id: '14', text: 'Tipo de amparo', iconCss: 'e-icons e-bookmark', shortcut: '[Tipo_Amparo]'  },
        { id: '15', text: 'Actor', iconCss: 'e-icons e-bookmark', shortcut: '[Actor]'  },
        { id: '16', text: 'Demandado', iconCss: 'e-icons e-bookmark', shortcut: '[Demandado]'  },
        { id: '17', text: 'Partes de amparo', iconCss: 'e-icons e-bookmark', shortcut: '[Partes_Amparo]'  },
        { id: '18', text: 'Tipo de notificación', iconCss: 'e-icons e-bookmark', shortcut: '[Tipo_Notificacion]'  },
        { id: '19', text: 'Forma de notificación', iconCss: 'e-icons e-bookmark', shortcut: '[Forma_Notificacion]'  },
        { id: '20', text: 'Acuerdo a notificar', iconCss: 'e-icons e-bookmark', shortcut: '[Acuerdo_Notificar]'  },
        { id: '21', text: 'Domicilio a notificar', iconCss: 'e-icons e-bookmark', shortcut: '[Domicilio_Notificar]'  },
        { id: '22', text: 'Persona a notificar', iconCss: 'e-icons e-bookmark', shortcut: '[Persona_Notificar]'  },
    ];

    const items: ItemModel[] = campos.flatMap((campo, index) => {

        const item: ItemModel = {
            id: campo.id,
            text: campo.text,
            iconCss: 'e-icons e-bookmark'
        };

        if ( index === campos.length - 1 ) {
            return [item];
        }

        return [item, { separator: true }];
    });

    const shortcuts = Object.fromEntries(
        campos.map(c => [c.id, c.shortcut])
    );

    const dropCampos = useRef(new DropDownButton({
        items,
        select: (args: MenuEventArgs) => {

            const id = args.item?.id as string;

            const shortcut = shortcuts[id];

            if ( shortcut ) {
                syncfusionEditor.current?.documentEditor.editor.insertText( shortcut );
            }
        }

    }));

    let downDrop: CustomToolbarItemModel = {
        tooltipText: 'Atajos',
        text: 'Atajos',
        id: 'dropItem',
        prefixIcon: "e-icons e-drop-down",
    };

    let Toolbar: ( CustomToolbarItemModel | ToolbarItem )[] = [
        'New',
        'Open',
        'Separator',
        'Undo',
        'Redo',
        'Separator',
        'Image',
        'Table',
        'Separator',
        'Header',
        'Footer',
        'Separator',
        downDrop,
    ];

    const handleAgregarPlantilla = async () => {

        setLoadingGuardar( true );

        const params: PlantillaProps = {
            idPlantilla: 0,
            contenido: syncfusionEditor.current?.documentEditor.serialize() ?? "",
            descripcion: nombrePlantilla.trim(),
            idAutoridad: autoridad,
            idTipoAcuerdo: tipoAcuerdo,
            idSubTipoAcuerdo: subtipoAcuerdo,
            idTipoNotificacion: tipoNotificacion,
            activo: true,
        }

        await AgregarPlantilla( params ).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    dispatch( openSnackbar({ message: message, variant: 'success' }));

                    syncfusionEditor.current?.documentEditor.open( defaultDocument );

                    setOpen( false );
                    setLoadingGuardar(false);
                    limpiarDatos();

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }));

                    setOpen( false );
                    setLoadingGuardar(false);

                }

            }, 700);

        });

    }

    const handleActualizarPlantilla = async () => {

        setLoadingGuardar( true );

        const plantillaActual = plantillaArray.find( (( { idPlantilla }) => idPlantilla === plantilla ));

        const params: PlantillaProps = {
            idPlantilla: plantillaActual?.idPlantilla ?? 0,
            contenido: syncfusionEditor.current?.documentEditor.serialize() ?? "",
            descripcion: plantillaActual?.descripcion ?? "",
            idAutoridad: plantillaActual?.idAutoridad ?? 0,
            idTipoAcuerdo: plantillaActual?.idTipoAcuerdo ?? 0,
            idSubTipoAcuerdo: plantillaActual?.idSubTipoAcuerdo ?? 0,
            idTipoNotificacion: plantillaActual?.idTipoNotificacion ?? 0,
            activo: plantillaActual?.activo ?? false,
        }

        await ActualizarPlantilla( params ).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    const plantillas: PlantillaProps[] = plantillaArray.filter( (( { idPlantilla }) => idPlantilla !== plantilla ));

                    setPlantillaArray([ ...plantillas, params ]);

                    dispatch( openSnackbar({ message: message, variant: 'success' }));

                    setLoadingGuardar( false );
                    setOpen(false);

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }));

                    setLoadingGuardar( false );
                    setOpen(false);

                }

            }, 700);

        });

    }

    const handleActualizarActivo = async( activo: boolean )  => {

        const plantillaActual = plantillaArray.find( (( { idPlantilla }) => idPlantilla === plantilla ));

        const params: PlantillaProps = {
            idPlantilla: plantillaActual?.idPlantilla ?? 0,
            contenido: plantillaActual?.contenido ?? "",
            descripcion: plantillaActual?.descripcion ?? "",
            idAutoridad: plantillaActual?.idAutoridad ?? 0,
            idTipoAcuerdo: plantillaActual?.idTipoAcuerdo ?? 0,
            idSubTipoAcuerdo: plantillaActual?.idSubTipoAcuerdo ?? 0,
            idTipoNotificacion: plantillaActual?.idTipoNotificacion ?? 0,
            activo,
        }

        await ActualizarPlantilla( params ).then( resp => {

            const { success, message } = resp;

            if ( success ) {

                const plantillas: PlantillaProps[] = plantillaArray.filter( (( { idPlantilla }) => idPlantilla !== plantilla ));

                setPlantillaArray([ ...plantillas, params ]);

                dispatch( openSnackbar({ message: message, variant: 'success' }));

                setActivarPlantilla( activo );

            }
            else {

                dispatch( openSnackbar({ message: message, variant: 'error' }));

            }

        });

    }

    const handleOpenConfirmacion = () => {

        const validate = validateFields();

        if ( !validate ) {
            return false;
        }

        setOpen(true );

    }

    const validateFields = () => {

        let valid = true;

        if ( tipoAccion === 'Nueva plantilla' ) {

            if ( nombrePlantilla.trim() === '' ) {
                valid = false;
                dispatch( openSnackbar({ message: 'Debes escribir el nombre de la plantilla', variant: 'warning' }));
            }

            if ( autoridad === 0 ) {
                valid = false;
                dispatch( openSnackbar({ message: 'Debes seleccionar la autoridad', variant: 'warning' }));
            }

            if ( tipoPlantilla === 'Acuerdos' ) {

                if ( tipoAcuerdo === 0 ) {
                    valid = false;
                    dispatch( openSnackbar({ message: 'Debes seleccionar el tipo de acuerdo', variant: 'warning' }));
                }

                if ( tipoAcuerdo !== 0 && subtipoAcuerdo === 0 && subtipoAcuerdoArray.length !== 0 ) {
                    valid = false;
                    dispatch( openSnackbar({ message: 'Debes seleccionar el subtipo de acuerdo', variant: 'warning' }));
                }

            }
            else if ( tipoPlantilla === 'Notificacion' ) {

                if ( tipoNotificacion === 0 ) {
                    valid = false;
                    dispatch( openSnackbar({ message: 'Debes seleccionar el tipo de notificación', variant: 'warning' }));
                }

            }

        }
        else {

            if ( plantilla === 0 ) {
                valid = false;
                dispatch( openSnackbar({ message: 'Debes seleccionar una plantilla', variant: 'warning' }));
            }

            if ( autoridad === 0 ) {
                valid = false;
                dispatch( openSnackbar({ message: 'Debes seleccionar la autoridad', variant: 'warning' }));
            }

        }

        return valid;
    }

    const limpiarDatos = () => {

        setAutoridad( 0 );
        setsubTipoAcuerdo( 0 );
        setTipoAcuerdo( 0 );
        setTipoNotificacion( 0 );

        setPlantillaArray( [] );
        setPlantilla( 0 );
        setNombrePlantilla( '' );

        syncfusionEditor.current?.documentEditor.open( defaultDocument );
    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerAutoridades().then( resp => {
                setAutoridadArray( resp );
            });

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoAcuerdo().then( resp => {
                setTipoAcuerdoArray( resp );
            });

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoNotificacion().then( resp => {
                setTipoNotificacionArray( resp );
            });

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            setsubTipoAcuerdo( 0 );
            setSubTipoAcuerdoArray( [] );

            await ObtenerSubTipoAcuerdo( tipoAcuerdo ).then( resp => {
                setSubTipoAcuerdoArray( resp );
            });

        }

        Obtener();

    }, [ tipoAcuerdo ])

    useEffect(() => {

        setPlantilla( 0 );
        setPlantillaArray( [] );

        async function Obtener(){

            await ObtenerPlantillasAdmin({ idAutoridad: autoridad, idTipoAcuerdo: tipoAcuerdo, idSubTipoAcuerdo: subtipoAcuerdo, idTipoNotificacion: tipoNotificacion }).then( resp => {
                setPlantillaArray( resp );
            });

        }

        if ( autoridad !== 0 ) {
            Obtener();
        }

    }, [ autoridad, tipoAcuerdo, subtipoAcuerdo, tipoNotificacion ])

    const handleEditorCreated = () => {
        setEditorReady( true );
    };

    useEffect(() => {

        if ( editorReady && syncfusionEditor.current && !loading ) {

            syncfusionEditor.current.documentEditor.open( defaultDocument );
            syncfusionEditor.current.documentEditorSettings.showRuler = true;
            syncfusionEditor.current.documentEditor.pageOutline = '#E0E0E0';

            dropCampos.current.appendTo('#dropItem');

        }

    }, [ loading, editorReady ])

    useEffect(() => {

        if ( !editorReady ) return;

        if ( plantilla !== 0 && plantillaArray.length !== 0 ) {

            const plantillaFind = plantillaArray.find(( ( elem ) => elem.idPlantilla === plantilla ));

            if ( syncfusionEditor.current && plantillaFind ) {

                syncfusionEditor.current?.documentEditor.open( plantillaFind.contenido );

                setActivarPlantilla( plantillaFind.activo );

            }
            else {

                syncfusionEditor.current?.documentEditor.open( defaultDocument );

                setActivarPlantilla( false );

            }

        }

        if ( plantilla === 0 ) {

            syncfusionEditor.current?.documentEditor.open( defaultDocument );

        }

    }, [ plantilla, plantillaArray, editorReady ])

    useEffect(() => {

        setLoading( true );

        setTimeout(() => {

            setLoading( false );

        }, 700);

    }, [ ])

    return (
        <Layout breadcrumbs={ [ { text: 'Administración' }, { text: 'Plantilla(s)' } ] } backgroundPaper={ false }>

            {
                loading
                ?
                    <Box height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                        <CircularProgressIndicator />
                    </Box>
                :
                    <Grid container spacing={ 1 }>

                        <Grid size={{ xs: 12 }} textAlign={ 'start' }>

                            <Button color="secondary" variant="text" sx={{ mt: 1 }} startIcon={ <UndoIcon /> } onClick={ () => navigate('/') }>
                                Regresar
                            </Button>

                        </Grid>

                        <Grid size={{ xs: 12 }}>

                            <Paper sx={{ p: 4 }}>

                                <Grid container spacing={ 3 }>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <FormControl>

                                            <FormLabel>¿Seleccione el tipo de movimiento?</FormLabel>

                                            <RadioGroup row onChange={ limpiarDatos } >
                                                <FormControlLabel control={ <Radio checked={ tipoAccion === 'Nueva plantilla' } onChange={ () => setTipoAccion( 'Nueva plantilla' ) } /> } label="Nueva plantilla" />
                                                <FormControlLabel control={ <Radio checked={ tipoAccion === 'Modificar plantilla' } onChange={ () => setTipoAccion( 'Modificar plantilla' ) } /> } label="Modificar plantilla" />
                                            </RadioGroup>

                                        </FormControl>

                                    </Grid>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <FormControl>

                                            <FormLabel>Tipo de plantilla:</FormLabel>

                                            <RadioGroup row onChange={ limpiarDatos } >

                                                <FormControlLabel
                                                    label="Acuerdo(s)"
                                                    control={ <Radio checked={ tipoPlantilla === 'Acuerdos' }
                                                    onChange={ () => setTipoPlantilla( 'Acuerdos' ) } /> }
                                                />

                                                <FormControlLabel
                                                    label="Notificación"
                                                    control={ <Radio checked={ tipoPlantilla === 'Notificacion' }
                                                    onChange={ () => setTipoPlantilla( 'Notificacion' ) } /> }
                                                />

                                            </RadioGroup>

                                        </FormControl>

                                    </Grid>

                                    {
                                        tipoPlantilla === 'Acuerdos'
                                        &&
                                            <>

                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <FormControl fullWidth>

                                                        <InputLabel>Tipo de acuerdo</InputLabel>

                                                        <Select
                                                            label="Tipo de acuerdo"
                                                            value={ tipoAcuerdo }
                                                            onChange={ (e) => setTipoAcuerdo( e.target.value ) }
                                                        >
                                                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                            {
                                                                tipoAcuerdoArray.map(({ idTipoAcuerdo, descripcion }) => (
                                                                    <MenuItem key={ idTipoAcuerdo } value={ idTipoAcuerdo }> { descripcion } </MenuItem>
                                                                ))
                                                            }
                                                        </Select>

                                                    </FormControl>

                                                </Grid>

                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <FormControl fullWidth>

                                                        <InputLabel>Subtipo de acuerdo</InputLabel>

                                                        <Select
                                                            label="Subtipo de acuerdo"
                                                            value={ subtipoAcuerdo }
                                                            onChange={ (e) => setsubTipoAcuerdo( e.target.value ) }
                                                            disabled={ tipoAcuerdo === 0 || subtipoAcuerdoArray.length === 0 }
                                                        >
                                                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                            {
                                                                subtipoAcuerdoArray.map(({ idSubTipoAcuerdo, descripcion }) => (
                                                                    <MenuItem key={ idSubTipoAcuerdo } value={ idSubTipoAcuerdo }> { descripcion } </MenuItem>
                                                                ))
                                                            }
                                                        </Select>

                                                    </FormControl>

                                                </Grid>

                                            </>
                                    }

                                    {
                                        tipoPlantilla === 'Notificacion'
                                        &&
                                            <Grid size={{ md: 12, xs: 12 }}>

                                                <FormControl fullWidth>

                                                    <InputLabel>Tipo de notificación</InputLabel>

                                                    <Select
                                                        label="Tipo de notificación"
                                                        value={ tipoNotificacion }
                                                        onChange={ (e) => setTipoNotificacion( e.target.value ) }
                                                    >
                                                        <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                        {
                                                            tipoNotificacionArray.map(({ idTipoNotificacion, descripcion }) => (
                                                                <MenuItem key={ idTipoNotificacion } value={ idTipoNotificacion }> { descripcion } </MenuItem>
                                                            ))
                                                        }
                                                    </Select>

                                                </FormControl>

                                            </Grid>
                                    }

                                    <Grid size={{ md: 12, xs: 12 }}>

                                        <FormControl fullWidth>

                                            <InputLabel>Autoridad</InputLabel>

                                            <Select
                                                label="Autoridad"
                                                value={ autoridad }
                                                onChange={ (e) => setAutoridad( e.target.value ) }
                                                disabled={
                                                    ( tipoPlantilla === 'Acuerdos' && tipoAcuerdo === 0 ) ||
                                                    ( tipoPlantilla === 'Acuerdos' && tipoAcuerdo !== 0 && subtipoAcuerdo === 0 && subtipoAcuerdoArray.length !== 0 ) ||
                                                    ( tipoPlantilla === 'Notificacion' && tipoNotificacion === 0 )
                                                }
                                            >
                                                <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                {
                                                    autoridadArray
                                                    .filter( ({ idAutoridad }) => idAutoridad === 6 )
                                                    .map(({ idAutoridad, descripcion }) => (
                                                        <MenuItem key={ idAutoridad } value={ idAutoridad }> { descripcion } </MenuItem>
                                                    ))
                                                }
                                            </Select>

                                        </FormControl>

                                    </Grid>

                                    {
                                        tipoAccion === 'Nueva plantilla'
                                        &&
                                            <Grid size={{ md: 12, xs: 12 }}>

                                                <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    label='Nombre de la plantilla'
                                                    placeholder="Escribe el nombre de la plantilla"
                                                    slotProps={{
                                                        input: {
                                                            autoComplete: 'off'
                                                        },
                                                        inputLabel: {
                                                            shrink: true,
                                                        }
                                                    }}
                                                    value={ nombrePlantilla }
                                                    onChange={ (e) => setNombrePlantilla( e.target.value ) }
                                                />

                                            </Grid>
                                    }

                                    {
                                        tipoAccion === 'Modificar plantilla'
                                        &&
                                            <>
                                                <Grid size={{ md: plantilla !== 0 ? 10 : 12, xs: 12 }}>

                                                    <FormControl fullWidth>

                                                        <InputLabel>Plantilla(s)</InputLabel>

                                                        <Select
                                                            label="Plantilla(s)"
                                                            value={ plantilla }
                                                            onChange={ (e) => setPlantilla( e.target.value ?? 0 ) }
                                                            disabled={
                                                                ( tipoPlantilla === 'Acuerdos' && tipoAcuerdo === 0 ) ||
                                                                ( tipoPlantilla === 'Notificacion' && tipoNotificacion === 0 ) ||
                                                                autoridad === 0
                                                            }
                                                        >
                                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                                            {
                                                                plantillaArray.map(({ idPlantilla, descripcion }) => (
                                                                    <MenuItem key={ idPlantilla } value={ idPlantilla }> { descripcion } </MenuItem>
                                                                ))
                                                            }
                                                        </Select>

                                                    </FormControl>

                                                </Grid>

                                                {
                                                    plantilla !== 0
                                                    &&
                                                        <Grid size={{ md: 2, xs: 12 }}>

                                                            <FormControl>

                                                                <FormLabel component="legend">Activar plantilla</FormLabel>

                                                                <FormGroup>

                                                                    <FormControlLabel
                                                                        control={
                                                                            <Switch
                                                                                checked={ activarPlantilla }
                                                                                onChange={ (e) => handleActualizarActivo( e.target.checked ) }
                                                                            />
                                                                        }
                                                                        label=""
                                                                    />

                                                                </FormGroup>

                                                            </FormControl>

                                                        </Grid>
                                                }

                                            </>
                                    }

                                    <Grid size={{ md: 12, xs: 12 }}>

                                        <DocumentEditorContainerComponent
                                            key='DocumentEditorContainer'
                                            serviceUrl={ process.env.REACT_APP_URL_SERVICE_DOCUMENT_EDITOR ?? '' }
                                            height='650'
                                            ref={ syncfusionEditor }
                                            enableToolbar={ true }
                                            showPropertiesPane={ false }
                                            toolbarItems={ Toolbar }
                                            autoResizeOnVisibilityChange={ false }
                                            created={ handleEditorCreated }
                                        >
                                        </DocumentEditorContainerComponent>

                                    </Grid>

                                    <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 3 }}>

                                        <Grid container spacing={ 3 }>

                                            <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'left'}}> </Grid>

                                            <Grid size={{ md: 4, xs: 12 }} style={{ textAlign: 'center' }}>

                                                <Button
                                                    fullWidth
                                                    color='primary'
                                                    variant="contained"
                                                    onClick={ handleOpenConfirmacion }
                                                >
                                                    Guardar
                                                </Button>

                                            </Grid>

                                            <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'right'}}> </Grid>

                                        </Grid>

                                    </Grid>

                                </Grid>

                            </Paper>

                        </Grid>

                    </Grid>
            }

            <Dialog
                fullWidth
                maxWidth='xs'
                open={ open }
                onClose={ () => { } }
            >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent sx={ DialogContentStyle }>

                    <DialogContentText>
                        {
                            tipoAccion === 'Nueva plantilla'
                            ?
                                '¿Desea generar una nueva plantilla?'
                            :
                                '¿Desea modificar la plantilla seleccionada?'
                        }
                    </DialogContentText>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button
                        color="secondary"
                        onClick={ () => setOpen( false ) }
                    >
                        Cancelar
                    </Button>

                    <Button
                        variant='contained'
                        loading={ loadingGuardar }
                        onClick={ tipoAccion === 'Nueva plantilla' ? handleAgregarPlantilla : handleActualizarPlantilla }
                    >
                        Aceptar
                    </Button>

                </DialogActions>

            </Dialog>

        </Layout>
    )
}